import { render, staticRenderFns } from "./OrderSimpleVehicleForm.vue?vue&type=template&id=abf18694"
import script from "./OrderSimpleVehicleForm.vue?vue&type=script&lang=js"
export * from "./OrderSimpleVehicleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports